// Mock Installments Matrix Data - İNSANET
// Excel benzeri aylık taksit tablosu verileri

// Yıl bazlı aylar (Ocak-Aralık)
export const getMonthsForYear = (year) => [
    { key: `${year}-01`, label: 'Oca', fullLabel: 'Ocak' },
    { key: `${year}-02`, label: 'Şub', fullLabel: 'Şubat' },
    { key: `${year}-03`, label: 'Mar', fullLabel: 'Mart' },
    { key: `${year}-04`, label: 'Nis', fullLabel: 'Nisan' },
    { key: `${year}-05`, label: 'May', fullLabel: 'Mayıs' },
    { key: `${year}-06`, label: 'Haz', fullLabel: 'Haziran' },
    { key: `${year}-07`, label: 'Tem', fullLabel: 'Temmuz' },
    { key: `${year}-08`, label: 'Ağu', fullLabel: 'Ağustos' },
    { key: `${year}-09`, label: 'Eyl', fullLabel: 'Eylül' },
    { key: `${year}-10`, label: 'Eki', fullLabel: 'Ekim' },
    { key: `${year}-11`, label: 'Kas', fullLabel: 'Kasım' },
    { key: `${year}-12`, label: 'Ara', fullLabel: 'Aralık' },
];

// Mevcut yıllar
export const availableYears = [2025, 2026, 2027];

// Taksit durumları
export const installmentStatuses = {
    paid: { label: 'Ödendi', color: 'bg-success', textColor: 'text-success' },
    pending: { label: 'Bekliyor', color: 'bg-warning', textColor: 'text-warning' },
    overdue: { label: 'Gecikti', color: 'bg-error', textColor: 'text-error' },
    empty: { label: '-', color: 'bg-neutral-100', textColor: 'text-neutral-400' },
};

// Matrix verileri (10 kişi)
export const mockInstallmentsMatrix = [
    {
        id: 'inst-1',
        personId: 'ind-1',
        personName: 'Ahmet Yılmaz',
        apartmentNo: 'A-3',
        constructionId: 'c1',
        months: {
            '2025-08': { amount: 50000, status: 'paid', paidDate: '2025-08-15' },
            '2025-09': { amount: 50000, status: 'paid', paidDate: '2025-09-12' },
            '2025-10': { amount: 50000, status: 'paid', paidDate: '2025-10-18' },
            '2025-11': { amount: 50000, status: 'paid', paidDate: '2025-11-10' },
            '2025-12': { amount: 50000, status: 'paid', paidDate: '2025-12-14' },
            '2026-01': { amount: 50000, status: 'pending', dueDate: '2026-01-15' },
            '2026-02': { amount: 50000, status: 'pending', dueDate: '2026-02-15' },
            '2026-03': { amount: 50000, status: 'pending', dueDate: '2026-03-15' },
            '2026-04': { amount: 50000, status: 'pending', dueDate: '2026-04-15' },
            '2026-05': { amount: 50000, status: 'pending', dueDate: '2026-05-15' },
            '2026-06': { amount: 50000, status: 'pending', dueDate: '2026-06-15' },
            '2026-07': { amount: 50000, status: 'pending', dueDate: '2026-07-15' },
        }
    },
    {
        id: 'inst-2',
        personId: 'ind-2',
        personName: 'Fatma Demir',
        apartmentNo: 'A-5',
        constructionId: 'c1',
        months: {
            '2025-08': { amount: 60000, status: 'paid', paidDate: '2025-08-20' },
            '2025-09': { amount: 60000, status: 'paid', paidDate: '2025-09-18' },
            '2025-10': { amount: 60000, status: 'paid', paidDate: '2025-10-22' },
            '2025-11': { amount: 60000, status: 'paid', paidDate: '2025-11-19' },
            '2025-12': { amount: 60000, status: 'overdue', dueDate: '2025-12-15' },
            '2026-01': { amount: 60000, status: 'overdue', dueDate: '2026-01-15' },
            '2026-02': { amount: 60000, status: 'pending', dueDate: '2026-02-15' },
            '2026-03': { amount: 60000, status: 'pending', dueDate: '2026-03-15' },
        }
    },
    {
        id: 'inst-3',
        personId: 'ind-3',
        personName: 'Mehmet Kaya',
        apartmentNo: 'B-2',
        constructionId: 'c1',
        months: {
            '2025-09': { amount: 45000, status: 'paid', paidDate: '2025-09-05' },
            '2025-10': { amount: 45000, status: 'paid', paidDate: '2025-10-08' },
            '2025-11': { amount: 45000, status: 'paid', paidDate: '2025-11-12' },
            '2025-12': { amount: 45000, status: 'paid', paidDate: '2025-12-10' },
            '2026-01': { amount: 45000, status: 'pending', dueDate: '2026-01-10' },
            '2026-02': { amount: 45000, status: 'pending', dueDate: '2026-02-10' },
            '2026-03': { amount: 45000, status: 'pending', dueDate: '2026-03-10' },
            '2026-04': { amount: 45000, status: 'pending', dueDate: '2026-04-10' },
            '2026-05': { amount: 45000, status: 'pending', dueDate: '2026-05-10' },
            '2026-06': { amount: 45000, status: 'pending', dueDate: '2026-06-10' },
        }
    },
    {
        id: 'inst-4',
        personId: 'ind-4',
        personName: 'Ayşe Öztürk',
        apartmentNo: 'B-4',
        constructionId: 'c2',
        months: {
            '2025-10': { amount: 80000, status: 'paid', paidDate: '2025-10-25' },
            '2025-11': { amount: 80000, status: 'paid', paidDate: '2025-11-22' },
            '2025-12': { amount: 80000, status: 'paid', paidDate: '2025-12-20' },
            '2026-01': { amount: 80000, status: 'pending', dueDate: '2026-01-20' },
            '2026-02': { amount: 80000, status: 'pending', dueDate: '2026-02-20' },
            '2026-03': { amount: 80000, status: 'pending', dueDate: '2026-03-20' },
            '2026-04': { amount: 80000, status: 'pending', dueDate: '2026-04-20' },
            '2026-05': { amount: 80000, status: 'pending', dueDate: '2026-05-20' },
        }
    },
    {
        id: 'inst-5',
        personId: 'ind-5',
        personName: 'Ali Çelik',
        apartmentNo: 'C-1',
        constructionId: 'c1',
        months: {
            '2025-08': { amount: 55000, status: 'paid', paidDate: '2025-08-10' },
            '2025-09': { amount: 55000, status: 'paid', paidDate: '2025-09-08' },
            '2025-10': { amount: 55000, status: 'overdue', dueDate: '2025-10-10' },
            '2025-11': { amount: 55000, status: 'overdue', dueDate: '2025-11-10' },
            '2025-12': { amount: 55000, status: 'overdue', dueDate: '2025-12-10' },
            '2026-01': { amount: 55000, status: 'overdue', dueDate: '2026-01-10' },
            '2026-02': { amount: 55000, status: 'pending', dueDate: '2026-02-10' },
            '2026-03': { amount: 55000, status: 'pending', dueDate: '2026-03-10' },
        }
    },
    {
        id: 'inst-6',
        personId: 'ind-6',
        personName: 'Zeynep Arslan',
        apartmentNo: 'B-6',
        constructionId: 'c1',
        months: {
            '2025-08': { amount: 48000, status: 'paid', paidDate: '2025-08-18' },
            '2025-09': { amount: 48000, status: 'paid', paidDate: '2025-09-15' },
            '2025-10': { amount: 48000, status: 'paid', paidDate: '2025-10-12' },
            '2025-11': { amount: 48000, status: 'paid', paidDate: '2025-11-14' },
            '2025-12': { amount: 48000, status: 'paid', paidDate: '2025-12-16' },
            '2026-01': { amount: 48000, status: 'paid', paidDate: '2026-01-08' },
            '2026-02': { amount: 48000, status: 'pending', dueDate: '2026-02-15' },
            '2026-03': { amount: 48000, status: 'pending', dueDate: '2026-03-15' },
            '2026-04': { amount: 48000, status: 'pending', dueDate: '2026-04-15' },
            '2026-05': { amount: 48000, status: 'pending', dueDate: '2026-05-15' },
        }
    },
    {
        id: 'inst-7',
        personId: 'ind-7',
        personName: 'Mustafa Şahin',
        apartmentNo: 'A-8',
        constructionId: 'c2',
        months: {
            '2025-11': { amount: 70000, status: 'paid', paidDate: '2025-11-05' },
            '2025-12': { amount: 70000, status: 'paid', paidDate: '2025-12-08' },
            '2026-01': { amount: 70000, status: 'pending', dueDate: '2026-01-05' },
            '2026-02': { amount: 70000, status: 'pending', dueDate: '2026-02-05' },
            '2026-03': { amount: 70000, status: 'pending', dueDate: '2026-03-05' },
            '2026-04': { amount: 70000, status: 'pending', dueDate: '2026-04-05' },
            '2026-05': { amount: 70000, status: 'pending', dueDate: '2026-05-05' },
            '2026-06': { amount: 70000, status: 'pending', dueDate: '2026-06-05' },
        }
    },
    {
        id: 'inst-8',
        personId: 'ind-8',
        personName: 'Elif Erdoğan',
        apartmentNo: 'C-3',
        constructionId: 'c1',
        months: {
            '2025-09': { amount: 52000, status: 'paid', paidDate: '2025-09-20' },
            '2025-10': { amount: 52000, status: 'paid', paidDate: '2025-10-18' },
            '2025-11': { amount: 52000, status: 'paid', paidDate: '2025-11-22' },
            '2025-12': { amount: 52000, status: 'paid', paidDate: '2025-12-19' },
            '2026-01': { amount: 52000, status: 'pending', dueDate: '2026-01-20' },
            '2026-02': { amount: 52000, status: 'pending', dueDate: '2026-02-20' },
            '2026-03': { amount: 52000, status: 'pending', dueDate: '2026-03-20' },
            '2026-04': { amount: 52000, status: 'pending', dueDate: '2026-04-20' },
        }
    },
    {
        id: 'inst-9',
        personId: 'ind-9',
        personName: 'Hüseyin Yıldız',
        apartmentNo: 'B-9',
        constructionId: 'c2',
        months: {
            '2025-10': { amount: 65000, status: 'paid', paidDate: '2025-10-10' },
            '2025-11': { amount: 65000, status: 'paid', paidDate: '2025-11-08' },
            '2025-12': { amount: 65000, status: 'paid', paidDate: '2025-12-12' },
            '2026-01': { amount: 65000, status: 'pending', dueDate: '2026-01-10' },
            '2026-02': { amount: 65000, status: 'pending', dueDate: '2026-02-10' },
            '2026-03': { amount: 65000, status: 'pending', dueDate: '2026-03-10' },
            '2026-04': { amount: 65000, status: 'pending', dueDate: '2026-04-10' },
            '2026-05': { amount: 65000, status: 'pending', dueDate: '2026-05-10' },
            '2026-06': { amount: 65000, status: 'pending', dueDate: '2026-06-10' },
        }
    },
    {
        id: 'inst-10',
        personId: 'ind-10',
        personName: 'Selin Koç',
        apartmentNo: 'A-10',
        constructionId: 'c1',
        months: {
            '2025-12': { amount: 58000, status: 'paid', paidDate: '2025-12-05' },
            '2026-01': { amount: 58000, status: 'pending', dueDate: '2026-01-05' },
            '2026-02': { amount: 58000, status: 'pending', dueDate: '2026-02-05' },
            '2026-03': { amount: 58000, status: 'pending', dueDate: '2026-03-05' },
            '2026-04': { amount: 58000, status: 'pending', dueDate: '2026-04-05' },
            '2026-05': { amount: 58000, status: 'pending', dueDate: '2026-05-05' },
            '2026-06': { amount: 58000, status: 'pending', dueDate: '2026-06-05' },
            '2026-07': { amount: 58000, status: 'pending', dueDate: '2026-07-05' },
        }
    },
    // --- Yeni Veriler ---
    {
        id: 'inst-11', personId: 'ind-11', personName: 'Kemal Yılmaz', apartmentNo: 'A-10', constructionId: 'c1',
        months: {
            '2025-09': { amount: 50000, status: 'paid', paidDate: '2025-09-16' },
            '2025-10': { amount: 50000, status: 'paid', paidDate: '2025-10-15' },
            '2025-11': { amount: 50000, status: 'paid', paidDate: '2025-11-15' },
            '2025-12': { amount: 50000, status: 'paid', paidDate: '2025-12-15' },
            '2026-01': { amount: 50000, status: 'pending', dueDate: '2026-01-15' },
            '2026-02': { amount: 50000, status: 'pending', dueDate: '2026-02-15' },
            '2026-03': { amount: 50000, status: 'pending', dueDate: '2026-03-15' },
            '2026-04': { amount: 50000, status: 'pending', dueDate: '2026-04-15' },
        }
    },
    {
        id: 'inst-12', personId: 'ind-12', personName: 'Burcu Deniz', apartmentNo: 'B-12', constructionId: 'c2',
        months: {
            '2025-10': { amount: 70000, status: 'paid', paidDate: '2025-10-05' },
            '2025-11': { amount: 70000, status: 'paid', paidDate: '2025-11-02' },
            '2025-12': { amount: 70000, status: 'paid', paidDate: '2025-12-05' },
            '2026-01': { amount: 70000, status: 'pending', dueDate: '2026-01-05' },
            '2026-02': { amount: 70000, status: 'pending', dueDate: '2026-02-05' },
            '2026-03': { amount: 70000, status: 'pending', dueDate: '2026-03-05' },
        }
    },
    {
        id: 'inst-13', personId: 'ind-13', personName: 'Okan Kılıç', apartmentNo: 'C-5', constructionId: 'c1',
        months: {
            '2025-10': { amount: 50000, status: 'paid', paidDate: '2025-10-12' },
            '2025-11': { amount: 50000, status: 'paid', paidDate: '2025-11-10' },
            '2025-12': { amount: 50000, status: 'overdue', dueDate: '2025-12-10' },
            '2026-01': { amount: 50000, status: 'overdue', dueDate: '2026-01-10' },
            '2026-02': { amount: 50000, status: 'pending', dueDate: '2026-02-10' },
            '2026-03': { amount: 50000, status: 'pending', dueDate: '2026-03-10' },
        }
    },
    {
        id: 'inst-14', personId: 'ind-14', personName: 'Merve Korkmaz', apartmentNo: 'A-15', constructionId: 'c2',
        months: {
            '2025-11': { amount: 50000, status: 'paid', paidDate: '2025-11-08' },
            '2025-12': { amount: 50000, status: 'paid', paidDate: '2025-12-05' },
            '2026-01': { amount: 50000, status: 'pending', dueDate: '2026-01-05' },
            '2026-02': { amount: 50000, status: 'pending', dueDate: '2026-02-05' },
            '2026-03': { amount: 50000, status: 'pending', dueDate: '2026-03-05' },
        }
    },
    {
        id: 'inst-15', personId: 'ind-15', personName: 'Cem Altun', apartmentNo: 'B-18', constructionId: 'c2',
        months: {
            '2025-12': { amount: 50000, status: 'paid', paidDate: '2025-12-02' },
            '2026-01': { amount: 50000, status: 'pending', dueDate: '2026-01-02' },
            '2026-02': { amount: 50000, status: 'pending', dueDate: '2026-02-02' },
            '2026-03': { amount: 50000, status: 'pending', dueDate: '2026-03-02' },
        }
    },
];

// Helper fonksiyonlar
export const getInstallmentsMatrixByConstructionId = (constructionId) => {
    if (!constructionId) {
        return mockInstallmentsMatrix;
    }
    return mockInstallmentsMatrix.filter(item => item.constructionId === constructionId);
};

// Aylık toplamları hesapla (yıl bazlı)
export const calculateMonthlyTotals = (data, year) => {
    const months = getMonthsForYear(year);
    const totals = {};

    months.forEach(month => {
        totals[month.key] = {
            paid: 0,
            pending: 0,
            overdue: 0,
            total: 0
        };
    });

    data.forEach(person => {
        Object.entries(person.months).forEach(([monthKey, installment]) => {
            if (totals[monthKey]) {
                totals[monthKey].total += installment.amount;
                if (installment.status === 'paid') {
                    totals[monthKey].paid += installment.amount;
                } else if (installment.status === 'pending') {
                    totals[monthKey].pending += installment.amount;
                } else if (installment.status === 'overdue') {
                    totals[monthKey].overdue += installment.amount;
                }
            }
        });
    });

    return totals;
};

export default mockInstallmentsMatrix;
